import React from 'react'

import { useOperatorData } from '@contexts/operator/OperatorDataContext'
import { useOperatorNotification } from '@contexts/operator/OperatorNotificationContext'
import ListPageHeader from '@shared/ListPageHeader'
import ShipmentsList from '@shared/shipments/ShipmentsList'

import { shipmentService } from '@services/operator/shipmentService'

export default function OperatorShipmentsList() {
  const { addJob } = useOperatorNotification()
  const { merchantShippingTypes } = useOperatorData()

  return (
    <div>
      <ListPageHeader items={['shipments', 'shipments.list']} />
      <ShipmentsList
        role="operator"
        service={shipmentService}
        shippingTypes={merchantShippingTypes}
        addJob={addJob}
      />
    </div>
  )
}
